import type { ChipProps } from '@mui/material';
import { Chip, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { formatNumber } from '@weft/utils';
import React from 'react';

type PercentageChipProps = {
  oldValue: number,
  newValue: number,
} & ChipProps;

export const PercentageChip: React.FC<PercentageChipProps> = ({
  oldValue,
  newValue,
  ...props
}) => {
  const percentageDifference = getPercentageDifference(oldValue, newValue);
  const isPositiveDifference = percentageDifference >= 0;

  return (
    <Chip 
      variant='outlined'
      size='small'
      sx={{
        '&:hover': {
          boxShadow: 'none',
        },
      }}
      icon={
        <VyIcon icon={
          isPositiveDifference ? 'ArrowTopRight' : 'ArrowBottomRight'
        }
        />
      }
      color={isPositiveDifference ? 'success' : 'error'}
      label={
        <Typography
          fontSize="13px"
          lineHeight="18px"
          fontWeight={400}
          sx={{
            minWidth: '5ch',
            textAlign: 'end',
          }}
        >
          {formatNumber(Math.abs(percentageDifference)) + '%'}
        </Typography>
      }
      {...props}
    />
  );
};

function getPercentageDifference(oldValue: number, newValue: number) {
  if (oldValue === 0) {
    return 100;
  }

  return ((newValue - oldValue) / oldValue) * 100;
}